// import { Get, getAPIUrl, Post, Put } from "../../apiMethods";

// export const ordrEndpoint = {
//   createOrder: "restaurant/customer/create-order",
//   restaurentOrderRegister: "restaurant/customer/register",
//   updateOrder: "restaurant/order/update-order",
//   fetchOrderById: "restaurant/order/by-id",
//   fetchOrders: "restaurant/order/fetch-orders",
//   updateOrderStatus: "restaurant/order/update-status",
//   changePaymentstatus: "restaurant/order/complete-order-status",
//   finalize: "restaurant/group-order/place-order",
//   fetchOrderGroupSummery: "restaurant/group-order/order-summary/",
//   customer: {
//     currentOrder: "restaurant/customer/current-order",
//     currentGroupOrder: "restaurant/group-order/order-summary",
//     previousOrder: "restaurant/customer/previous-order",
//     previousGroupOrder: "restaurant/group-order/previous-orders",
//     createPayment: "restaurant/payment/create-order",
//     verifyPayment: "restaurant/payment/callback",
//   },
// };

// export const CreateOrder = (data, param = "") => {
//   const url = getAPIUrl(
//     window.location.pathname.includes("customer")
//       ? "restaurant/customer/create-order"
//       : ordrEndpoint.createOrder,
//     param
//   );
//   return Post(url, data);
// };

// export const RestaurentOrderRegister = (data, param = "") => {
//   const url = getAPIUrl(
//     window.location.pathname.includes("customer")
//       ? "restaurant/customer/register"
//       : ordrEndpoint.restaurentOrderRegister,
//     param
//   );
//   return Post(url, data);
// };

// export const finalizeGroupOrder = (data) => {
//   const url = getAPIUrl(ordrEndpoint.finalize);
//   return Post(url, data);
// };


// export const CreateGroupOrder = (data, param = "") => {
//   const url = getAPIUrl("restaurant/group-order/add-item", param);
//   return Post(url, data);
// };

// export const updateOrder = (data, param = "") => {
//   const url = getAPIUrl(ordrEndpoint.updateOrder, param);
//   return Put(url, data);
// };
// export const fetchOrderById = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.fetchOrderById, param);
//   return Get(url);
// };

// export const fetchOrderGroupSummery = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.fetchOrderGroupSummery, param);
//   return Get(url);
// };

// export const fetchOrders = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.fetchOrders, param);
//   return Get(url);
// };

// export const updateOrderStatus = (data, param = "") => {
//   const url = getAPIUrl(ordrEndpoint.updateOrderStatus, param);
//   return Put(url, data);
// };

// export const getPreviousOrder = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.customer.previousOrder, param);
//   return Get(url);
// };
// export const getPreviousGroupOrder = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.customer.previousGroupOrder, param);
//   return Get(url);
// };

// export const getCurrentOrder = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.customer.currentOrder, param);
//   return Get(url);
// };
// export const getCurrentGroupOrder = (param = "") => {
//   const url = getAPIUrl(ordrEndpoint.customer.currentGroupOrder, param);
//   return Get(url);
// };

// export const changePaymentStatus = (param = "", data) => {
//   const url = getAPIUrl(ordrEndpoint.changePaymentstatus, param);
//   return Post(url, data);
// };

// export const createCustomerPayment = (data) => {
//   const url = getAPIUrl(ordrEndpoint.customer.createPayment);
//   return Post(url, data);
// };
// export const verifyCustomerPayment = (data) => {
//   const url = getAPIUrl(ordrEndpoint.customer.verifyPayment);
//   return Post(url, data);
// };

// export const getSingleOrderById = (params) => {
//   const url = getAPIUrl("restaurant/order/by-id", params);
//   return Get(url);
// };


import { Get, getAPIUrl, Post, Put } from "../../apiMethods";

export const ordrEndpoint = {
  createRestaurantOrder: "restaurant/order/create-order",
  createOrder: "restaurant/customer/create-order",
  restaurentOrderRegister: "restaurant/customer/register",
  updateOrder: "restaurant/order/update-order",
  fetchOrderById: "restaurant/order/by-id",
  fetchOrders: "restaurant/order/fetch-orders",
  updateOrderStatus: "restaurant/order/update-status",
  changePaymentstatus: "restaurant/order/complete-order-status",
  finalize: "restaurant/group-order/place-order",
  fetchOrderGroupSummery: "restaurant/group-order/order-summary/",
  customer: {
    currentOrder: "restaurant/customer/current-order",
    currentGroupOrder: "restaurant/group-order/order-summary",
    previousOrder: "restaurant/customer/previous-order",
    previousGroupOrder: "restaurant/group-order/previous-orders",
    createPayment: "restaurant/payment/create-order",
    verifyPayment: "restaurant/payment/callback",
  },
};

// Get single order by ID
export const getSingleOrderById = (params) => {
  const url = getAPIUrl(ordrEndpoint.fetchOrderById, params);
  return Get(url);
};

export const CreateOrder = (data, param = "") => {
  const isCustomerOrder = window.location.hash.includes("order-by-customer");

  const url = getAPIUrl(
    isCustomerOrder
      ? "restaurant/customer/create-order"
      : "restaurant/order/create-order",
    param
  );
  return Post(url, data);
};

export const RestaurentOrderRegister = (data, param = "") => {
  const url = getAPIUrl(
    window.location.pathname.includes("customer")
      ? "restaurant/customer/register"
      : ordrEndpoint.restaurentOrderRegister,
    param
  );
  return Post(url, data);
};

export const finalizeGroupOrder = (data) => {
  const url = getAPIUrl(ordrEndpoint.finalize);
  return Post(url, data);
};

export const CreateGroupOrder = (data, param = "") => {
  const url = getAPIUrl("restaurant/group-order/add-item", param);
  return Post(url, data);
};

export const updateOrder = (data, param = "") => {
  const url = getAPIUrl(ordrEndpoint.updateOrder, param);
  return Put(url, data);
};

export const fetchOrderById = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.fetchOrderById, param);
  return Get(url);
};

export const fetchOrderGroupSummery = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.fetchOrderGroupSummery, param);
  return Get(url);
};

export const fetchOrders = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.fetchOrders, param);
  return Get(url);
};

export const updateOrderStatus = (data, param = "") => {
  const url = getAPIUrl(ordrEndpoint.updateOrderStatus, param);
  return Put(url, data);
};

export const getPreviousOrder = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.customer.previousOrder, param);
  return Get(url);
};

export const getPreviousGroupOrder = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.customer.previousGroupOrder, param);
  return Get(url);
};

export const getCurrentOrder = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.customer.currentOrder, param);
  return Get(url);
};

export const getCurrentGroupOrder = (param = "") => {
  const url = getAPIUrl(ordrEndpoint.customer.currentGroupOrder, param);
  return Get(url);
};

export const changePaymentStatus = (param = "", data) => {
  const url = getAPIUrl(ordrEndpoint.changePaymentstatus, param);
  return Post(url, data);
};

export const createCustomerPayment = (data) => {
  const url = getAPIUrl(ordrEndpoint.customer.createPayment);
  return Post(url, data);
};

export const verifyCustomerPayment = (data) => {
  const url = getAPIUrl(ordrEndpoint.customer.verifyPayment);
  return Post(url, data);
};